module.exports = __webpack_public_path__ + "img/dataPark1.5af570e0.png";